import { Col } from "react-bootstrap";
import Drawer from "../../_metronic/layout/components/drawer/Drawer";
import Can from "../modules/Auth/Can";
import { useSubheader } from "../../_metronic/layout";
import NotificationAdminPage from "../sustell_15/components/notifications/admin/NotificationAdminPage";
import { useIntl } from "../../_metronic/i18n/customUseIntl";
import { HelpCenter } from "../modules/notifications/HelpCenter";
import featureFlags from "../sustell_15/utils/featureFlags";

const HelpCenterPage = () => {
  const intl = useIntl();
  const subheader = useSubheader();

  if (Can("access", "Admin pages")) {
    subheader.setTitle(intl.formatMessage({ id: "HELP_CENTER" }));
  }

  return Can("access", "Admin pages") ? (
    <Drawer>
      <Col>
        {featureFlags.notifications ? (
          <NotificationAdminPage category="HelpCenter" />
        ) : (
          <HelpCenter />
        )}
      </Col>
    </Drawer>
  ) : (
    <></>
  );
};

export default HelpCenterPage;
